import classNames from 'classnames';
import * as React from 'react';
import { IsMobileDevice } from 'source/app/domain/Device/Helpers/IsMobile';
import { ESharedFunction } from 'motw_core/Enums/ESharedFunction';
import { ShareState } from '../../services/UI/State/ShareState';
import { RenderDiv } from '../Shared/Render';
import * as styles from './Stars.css';

export function Stars() {
	let [ value, setValue ] = React.useState(100);

	ShareState(ESharedFunction.Stars, value, setValue);

	value = Math.min(Math.max(0, value), 100);
	const opacity = (100 - value) / 100;

	return (
		<RenderDiv id="starsContainer" when={IsMobileDevice()}>
			<div id="stars" style={{ opacity }}>
				<div
					className={classNames([ styles.stars ], [ styles.small ])}
				/>
				<div
					className={classNames([ styles.stars ], [ styles.medium ])}
				/>
				<div
					className={classNames([ styles.stars ], [ styles.large ])}
				/>
			</div>
		</RenderDiv>
	);
}
